import { GetEmailTemplateResult } from "tech-health-assessment-sdk/dist";
import { api } from "../../../../../services/core-api-service";

class AdminEmailTemplateService {
    public async getAdminEmailTemplate(emailTemplateId: string): Promise<GetEmailTemplateResult> {
        return api.admin.getEmailTemplate(emailTemplateId)
    }
}

export const service = new AdminEmailTemplateService()